module.exports = __webpack_public_path__ + "static/grandfix-a623cef4d641d43134db068b4c8d9039.jpg";